import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucchiphiphatsinhAction } from 'src/actions/newdanhmucchiphiphatsinh.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucchiphiphatsinhStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmucchiphiphatsinhLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucchiphiphatsinhIds, setSelectedNewdanhmucchiphiphatsinhIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucchiphiphatsinh);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucchiphiphatsinhAction.updateFilter(payload));
    dispatch(NewdanhmucchiphiphatsinhAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucchiphiphatsinhIds;

    if (event.target.checked) {
      newSelectedNewdanhmucchiphiphatsinhIds = items.map((newdanhmucchiphiphatsinh) => newdanhmucchiphiphatsinh.id);
    } else {
      newSelectedNewdanhmucchiphiphatsinhIds = [];
    }

    setSelectedNewdanhmucchiphiphatsinhIds(newSelectedNewdanhmucchiphiphatsinhIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucchiphiphatsinhIds.indexOf(id);
    let newSelectedNewdanhmucchiphiphatsinhIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucchiphiphatsinhIds = newSelectedNewdanhmucchiphiphatsinhIds.concat(selectedNewdanhmucchiphiphatsinhIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucchiphiphatsinhIds = newSelectedNewdanhmucchiphiphatsinhIds.concat(selectedNewdanhmucchiphiphatsinhIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucchiphiphatsinhIds.length - 1) {
      newSelectedNewdanhmucchiphiphatsinhIds = newSelectedNewdanhmucchiphiphatsinhIds.concat(selectedNewdanhmucchiphiphatsinhIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucchiphiphatsinhIds = newSelectedNewdanhmucchiphiphatsinhIds.concat(
        selectedNewdanhmucchiphiphatsinhIds.slice(0, selectedIndex),
        selectedNewdanhmucchiphiphatsinhIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucchiphiphatsinhIds(newSelectedNewdanhmucchiphiphatsinhIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucchiphiphatsinh) => {
    setSelected(newdanhmucchiphiphatsinh);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucchiphiphatsinhAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucchiphiphatsinhAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Mã
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Giá
                </TableCell>
                <TableCell>
                  Thời điểm tạo
                </TableCell>
                {(role.priority < 4) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucchiphiphatsinh, index) => (
                newdanhmucchiphiphatsinh ? <TableRow
                  hover
                  key={newdanhmucchiphiphatsinh.id}
                  selected={selectedNewdanhmucchiphiphatsinhIds.indexOf(newdanhmucchiphiphatsinh.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucchiphiphatsinh.ma}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucchiphiphatsinh.ten}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucchiphiphatsinh.gia ? numeral(newdanhmucchiphiphatsinh.gia).format('0,0[.]0') : 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(newdanhmucchiphiphatsinh.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 4) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucchiphiphatsinh.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucchiphiphatsinh)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucchiphiphatsinhLookupDetail;
